import { Loader } from '@entur/loader';
import { Drawer } from '@entur/modal';
import ErrorBoundary from 'app/components/ErrorBoundary';
import { useDrawer } from 'hooks/context/useDrawer';
import { Suspense } from 'react';
import { useIntl } from 'react-intl';

const CustomDrawer = () => {
  const intl = useIntl();
  const { isOpen, close, content } = useDrawer();

  return (
    <Drawer open={isOpen} onDismiss={() => close()} title="">
      <ErrorBoundary>
        <Suspense fallback={<Loader>{intl.formatMessage({ id: 'generalValues.loading' })}</Loader>}>{content}</Suspense>
      </ErrorBoundary>
    </Drawer>
  );
};

export default CustomDrawer;
